
const staticRoute = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        // component: () => import(/* webpackChunkName: 'login' */ '../page/login/login')
        component: () => import(/* webpackChunkName: 'login' */ '../page/login/loginDB')
    },
]

export default staticRoute


// WEBPACK FOOTER //
// ./src/router/staticRoute.js